/**
 * MermaidRenderer - Renderiza diagramas Mermaid.js em sandbox.
 *
 * O resize é detectado automaticamente pelo ResizeObserver do ArtifactSandbox
 * quando o SVG é inserido no DOM — não precisamos de notifyHeight() manual.
 */

export class MermaidRenderer {
    static renderToHtml(source: string): string {
        const escaped = source.replace(/`/g, '\\`').replace(/\$/g, '\\$');

        return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<style>
*, *::before, *::after { box-sizing: border-box; }
html, body { margin: 0; padding: 0; font-family: system-ui, -apple-system, sans-serif; background: transparent; }
body { padding: 16px; display: flex; justify-content: center; align-items: flex-start; }
#diagram { width: 100%; text-align: center; }
#diagram svg { max-width: 100%; height: auto; background: transparent !important; }
#diagram svg > rect:first-child { fill: transparent !important; }
#error {
    display: none; color: #dc2626; background: #fef2f2; border: 1px solid #fecaca;
    border-radius: 8px; padding: 16px; font-family: monospace; font-size: 13px;
    width: 100%; white-space: pre-wrap;
}
</style>
<script type="module">
import mermaid from 'https://cdn.jsdelivr.net/npm/mermaid@10/dist/mermaid.esm.min.mjs';

// 'strict' passes SVG output through DOMPurify, stripping all event handler attributes
// (onclick, onmouseover, etc.) — prevents script-src-attr CSP violations in the parent page.
mermaid.initialize({ startOnLoad: false, theme: 'default', securityLevel: 'strict' });

const source = \`${escaped}\`;

(async function () {
    try {
        const { svg } = await mermaid.render('mermaid-svg', source);
        document.getElementById('diagram').innerHTML = svg;
    } catch (err) {
        const el = document.getElementById('error');
        el.style.display = 'block';
        el.textContent = 'Mermaid Syntax Error:\\n' + err.message;
        document.getElementById('diagram').style.display = 'none';
    }
})();
</script>
</head>
<body>
<div id="error"></div>
<div id="diagram"></div>
</body>
</html>`;
    }
}
